<template>
  <div>
    <div  v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control-select" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :areaId_DBPJ="tipo.Id" :value="tipo.Id">{{tipo.Nombre}} un juzgado</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :areaId_DBPJ="tipo.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los juzgados</option>
        <option v-for="Area in Areas" :areaId_DBPJ="Area.AreaId_001DBPJ" :value="Area.AreaId" :key="Area.AreaId">{{Area.Area_PJ.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        Areas: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String 
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      deshabilitado: false
    },
    mounted() {      
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      
      //this.$store.dispatch("A_SICCIJ_Catalogo_Establecer001Area", parametros);
    },
    methods: {
      cargaCatalogoAreas() {        
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba      
                
        axios.post(api.conexion + api.SICCIJ.catalogos.C001Areas, this.parametros)
          .then(respuesta => {            
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {              
              this.Areas = respuesta.data.Areas;

              if (this.parametros.filtros != undefined && this.parametros.filtros != null) {
                this.Areas = respuesta.data.Areas.filter(cond => this.parametros.filtros.some(area => area == cond.AreaId));
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        this.$store.dispatch("A_SICCIJ_Catalogo_Establecer001Area", parametros);
        this.$emit("valorParaElPadre", [evento,this.Areas[evento.target.selectedIndex -1]]);
        
        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      }
    },
    created() {
      this.cargaCatalogoAreas();
    }
  }
</script>

<style scoped>
.form-control-select {
        background-color: white;
        color: rgb(63, 62, 62);
        border: none;
        position: relative;
        top: 5px;
        left: 20px;
        width: 300px;
    }
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Comun/Catalogos/001Areas.vue